import {
  REFRESH_DATA
} from '../../constants/actions';

const initialState = {
  favoritedList: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case REFRESH_DATA:
      return {...state, ...action.data};
    default:
      return state;
  }
}
